import { NgModule } from "@angular/core";
import { EffectsModule } from "@ngrx/effects";
import { StoreModule } from "@ngrx/store";
import { ContractChangeRequestEffect } from "./effect";
import { ContractChangeRequestReducer } from "./reducer";

@NgModule({
  imports: [EffectsModule.forFeature([ContractChangeRequestEffect]), StoreModule.forFeature("ccr", ContractChangeRequestReducer)]
})
export class ContractChangeRequestStoreModule {}

export const requestList = (store: any) => store && store.ccr && store.ccr.requestList;
export const requestByFieldList = (store: any) => store && store.ccr && store.ccr.requestByFieldList;
export const requestById = (store: any) => store && store.ccr && store.ccr.requestById;
export const addRequestResponse = (store: any) => store && store.ccr && store.ccr.addRequestResponse;
export const updateRequestResponse = (store: any) => store && store.ccr && store.ccr.updateRequestResponse;
export const deleteRequestResponse = (store: any) => store && store.ccr && store.ccr.deleteRequestResponse;
export const approveRejectRequestResponse = (store: any) => store && store.ccr && store.ccr.approveRejectRequestResponse;
